import React from "react";
import Container from "./container";
import { cn } from "../lib/helpers";
// import { useLocation } from '@reach/router';
import Icon from "./icon";

import * as styles from "../styles/components/newsletter.module.css";
import { Link } from "gatsby";

const Newsletter = (props) => {
  //  const {
  //   title
  // } = props;

  // const currentUrl = useLocation().href;

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   var xhr = new XMLHttpRequest();
  //   var url = "https://api.hsforms.com/submissions/v3/integration/submit/6309158/6059d735-7a95-47af-a0bd-f158ce218b57";
  //   In var url above, replace portalId and formId with your values from HubSpot.

  //   var message = document.getElementById('message');
  //   var email = document.getElementById('email');

  //   Example request JSON:
  //   var data = {
  //     submittedAt: Date.now(),
  //     fields: [
  //       {
  //         name: "email",
  //         value: email.value,
  //       },
  //     ],
  //     context: {
  //       pageUri: currentUrl,
  //       pageName: title,
  //     },
  //   };
  //   var final_data = JSON.stringify(data);
  //   xhr.open("POST", url);
  //   Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
  //   xhr.setRequestHeader("Content-Type", "application/json");
  //   xhr.onreadystatechange = function () {
  //     if (xhr.readyState === 4 && xhr.status === 200) {
  //       alert(xhr.responseText); // Returns a 200 response if the submission is successful.
  //       message.innerHTML = '<span class="success">Thank you for your submission.</span>';
  //       email.value = '';
  //     } else if (xhr.readyState === 4 && xhr.status === 400) {
  //       alert(xhr.responseText); // Returns a 400 error the submission is rejected.
  //       message.innerHTML = '<span class="fail">Your submission is rejected.</span>';
  //     } else if (xhr.readyState === 4 && xhr.status === 403) {
  //       alert(xhr.responseText); // Returns a 403 error if the portal isn't allowed to post submissions.
  //       message.innerHTML = '<span class="fail">The portal is not allowed to post submissions.</span>';
  //     } else if (xhr.readyState === 4 && xhr.status === 404) {
  //       alert(xhr.responseText); //Returns a 404 error if the formGuid isn't found
  //       message.innerHTML = '<span class="fail">The form is not found.</span>';
  //     }
  //   };
  //   Sends the request
  //   xhr.send(final_data);
  // };

  return (
    <div className={cn(styles.root, "color-palette-border-light")}>
      <Container>
        <div className={cn("grid align-center justify-center", styles.grid)}>
          <div className={cn("col-12 col-md-6", styles.col, styles.logo)}>
            <Icon symbol="logo-footer-2" />
          </div>
         
        </div>
      </Container>
    </div>
  );
};

export default Newsletter;

